/**
 * @generated SignedSource<<27a42495384c5de60d93636c460cbb7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DisplaySettingsModal_viewer$data = {
  readonly currencies: ReadonlyArray<string | null> | null;
  readonly geography: {
    readonly countries: ReadonlyArray<{
      readonly abbreviation: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly scandinavianCurrenciesEnabled: boolean | null;
  readonly " $fragmentType": "DisplaySettingsModal_viewer";
};
export type DisplaySettingsModal_viewer$key = {
  readonly " $data"?: DisplaySettingsModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplaySettingsModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplaySettingsModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencies",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Geography",
      "kind": "LinkedField",
      "name": "geography",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GeographyObject",
          "kind": "LinkedField",
          "name": "countries",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "abbreviation",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "scandinavianCurrenciesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "scandinavianCurrencies"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"scandinavianCurrencies\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7eeb012db502f351a4f3602f10333b0a";

export default node;
